import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import zhConvertor from 'zhconvertor';
import { getTopInterests } from '../../utils/interestTracker';
import './PersonalInterest.css';

// Chinese labels are stored traditional in parts of the app; convert to
// simplified unless the site language is zh_TW (matches SwingSeatsSection).
const tr = (text) =>
  text && localStorage.getItem('lang') !== 'zh_TW' ? zhConvertor.t2s(text) : text || '';

// Homepage "您可能关心的" — the visitor's most-clicked tags and seats, ranked by
// click count (recorded in the ge15_interests cookie by interestTracker.js).
// Tag items reopen the article-tag panel; seat items deep-link to the seat.
const PersonalInterestSection = ({ onTagClick }) => {
  const items = useMemo(() => getTopInterests(10), []);

  if (!items.length) return null;

  return (
    <section className="interest-section" aria-labelledby="interest-heading">
      <h2 id="interest-heading" className="section-title">
        {i18next.t('您可能关心的') || '您可能关心的'}
      </h2>
      <div className="interest-section__scroller">
        {items.map((item) =>
          item.type === 'tag' ? (
            <button
              key={`tag-${item.tag}`}
              type="button"
              className="interest-chip interest-chip--tag"
              onClick={() => onTagClick && onTagClick(item.tag)}
            >
              <span className="interest-chip__badge">{i18next.t('话题') || '话题'}</span>
              <span className="interest-chip__label">{tr(item.tag)}</span>
            </button>
          ) : (
            <Link
              key={`seat-${item.slug}-${item.seatname}`}
              className="interest-chip interest-chip--seat"
              to={`/seats/${item.slug}/n#s${item.seatname}`}
            >
              <span className="interest-chip__badge">{item.seatname}</span>
              <span className="interest-chip__label">{tr(item.label)}</span>
            </Link>
          )
        )}
      </div>
    </section>
  );
};

export default PersonalInterestSection;
